import { createJobFetchers } from "@artha/utils";

const APP_ORIGIN =
  process.env.NEXT_PUBLIC_APP_URL ||
  process.env.NEXT_PUBLIC_SITE_URL ||
  (process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : undefined) ||
  "http://localhost:3000";

const getJobApiBase = (baseUrl?: string) => {
  if (baseUrl) return baseUrl;
  return typeof window === "undefined"
    ? new URL("/api/job-api", APP_ORIGIN).toString()
    : "/api/job-api";
};

const jobFetchers = createJobFetchers({ getBaseUrl: getJobApiBase });

export const {
  fetchJobs,
  fetchPublicJobs,
  fetchPublicJobCount,
  fetchPublicJobFilters,
  fetchSimilarJobs,
  fetchRecommendSearch,
  fetchJobSuggestions,
  fetchJobBySlug,
  fetchFilters,
  fetchJobCount,
  buildQueryString,
} = jobFetchers;
